import React from "react";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import "../assets/styles/Certifications.scss";
import { useTranslation } from "react-i18next";
import { usePageTitle } from "../hooks/usePageTitle";

interface Cert {
  code: string;
  name: string;
  issuer: string;
  date: string;
  color: string;
  status: "obtained" | "in-progress" | "planned";
}

const certifications: Cert[] = [
  {
    code: "CCNA ITN",
    name: "CCNA R&S: Introduction to Networks",
    issuer: "Cisco Networking Academy",
    date: "2020",
    color: "#049FD9",
    status: "obtained",
  },
  {
    code: "NSE1",
    name: "Fortinet NSE 1 Network Security Associate",
    issuer: "Fortinet",
    date: "2022",
    color: "#EE3124",
    status: "obtained",
  },
  {
    code: "AZ-900",
    name: "Microsoft Azure Fundamentals",
    issuer: "Microsoft",
    date: "2023",
    color: "#0078d4",
    status: "obtained",
  },
  {
    code: "AZ-104",
    name: "Microsoft Azure Administrator",
    issuer: "Microsoft",
    date: "2024",
    color: "#0078d4",
    status: "obtained",
  },
  {
    code: "Associate Cloud Engineer",
    name: "Google Cloud Associate Cloud Engineer",
    issuer: "Google Cloud",
    date: "En cours",
    color: "#4285f4",
    status: "in-progress",
  },
  {
    code: "Terraform Associate",
    name: "HashiCorp Certified: Terraform Associate",
    issuer: "HashiCorp",
    date: "Objectif 2026",
    color: "#7b42bc",
    status: "planned",
  },
  {
    code: "CKA",
    name: "Certified Kubernetes Administrator",
    issuer: "CNCF",
    date: "Objectif 2026",
    color: "#326ce5",
    status: "planned",
  },
];

function Certifications() {
  const { t } = useTranslation();
  usePageTitle('Certifications');

  return (
    <section className="certs-section">
      <div className="certs-header">
        <h1>{t("certificationsTitle")}</h1>
        <div className="certs-rule" />
        <p className="certs-subtitle">{t("certificationsDesc")}</p>
      </div>

      <div className="certs-grid">
        {certifications.map((cert, i) => (
          <div
            key={i}
            className={`cert-card cert-card--${cert.status}`}
          >
            <div className="cert-icon" style={{ color: cert.color }}>
              <WorkspacePremiumIcon />
            </div>
            <div className="cert-body">
              <span className="cert-code" style={{ color: cert.color }}>
                {cert.code}
              </span>
              <h3 className="cert-name">{cert.name}</h3>
              <div className="cert-meta">
                <span className="cert-issuer">{cert.issuer}</span>
                <span className="cert-dot">·</span>
                <span className="cert-date">{cert.date}</span>
              </div>
            </div>
            {cert.status === "in-progress" && (
              <span className="cert-badge cert-badge--progress">{t("inProgress")}</span>
            )}
            {cert.status === "planned" && (
              <span className="cert-badge cert-badge--planned">{t("planned")}</span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Certifications;
